import React, { FunctionComponent } from 'react';
import ModalWithHeader from '../../../common/components/presentation/ModalWithHeader';
import Image from 'material-ui-image';
import TransferModalContent from './transferModalContent/TransferModalContent';
import TransferGroup from './transferGroup/TransferGroup';
import TransferActions from './transferActions/TransferActions';
import transferModalStyles from './transferModalStyles';
import { Box } from '@material-ui/core';
import ITransferGroup from '../../model/ITransferGroup';
import Translation from '../../../common/components/translation/Translation';

export interface ITransferModalProps {
  loading: boolean;
  isOpen: boolean;
  onlyInvalidOptions: boolean;
  currentModel: string;
  carSourceImage: string;
  transferGroups?: ITransferGroup[];
  onClose: () => void;
  onDeclineTransfer: () => void;
  onAcceptTransfer?: () => void;
}

const TransferModal: FunctionComponent<ITransferModalProps> = ({
  loading,
  isOpen,
  onClose,
  onDeclineTransfer,
  onAcceptTransfer,
  transferGroups,
  currentModel,
  carSourceImage,
  onlyInvalidOptions,
}) => {
  const styles = transferModalStyles();

  return (
    <ModalWithHeader
      loading={loading}
      open={isOpen}
      toggleModal={onClose}
      className={styles.dialogContent}
      title={<Translation id="trans__configurator__stock__transfer_modal_title" />}
      titleProps={{
        'data-test': 'title:transfer_modal',
        id: 'transferModal',
      }}
      contentProps={{
        'data-test': 'container:transfer_configurator',
      }}
    >
      <Box p={2}>
        <Image
          data-test="stock:transfer:image"
          src={carSourceImage}
          color="transparent"
          imageStyle={{ height: '100%', width: '100%', maxHeight: '180px', objectFit: 'contain' }}
          aspectRatio={2.8}
          animationDuration={0}
          alt={currentModel}
        />
        <TransferModalContent question="trans__configurator__stock__transfer_modal_question" />
        <TransferGroup currentModel={currentModel} transferGroups={transferGroups} />
      </Box>
      <TransferActions
        onDeclineTransfer={onDeclineTransfer}
        onAcceptTransfer={onAcceptTransfer}
        onlyInvalidOptions={onlyInvalidOptions}
      />
    </ModalWithHeader>
  );
};

export default TransferModal;
